import * as React from 'react';
import { Component } from 'react';
import styles from '../../styles/flyouts/products/Images.scss';
import * as _ from 'lodash';
import classNames from 'classnames';
import autobind from 'autobind-decorator';
import { setNotification } from '../../redux/actions/general/notification';
import {
  listProducts,
  readProduct,
  reorderProductImages,
} from '../../redux/actions/table/products';
import { __, mapStateToProps, setTableParams } from '../../core/utils';
import { showLightbox } from '../../redux/actions/general/lightbox';
import { ReactSortable } from 'react-sortablejs';
import GrabberIcon from '../../assets/images/grabber-16x16.svg';
import { hideDropdown } from '../../redux/actions/general/dropdown';
import {
  archiveAttachment,
  deleteAttachmentCurrentVersion,
  unarchiveAttachment,
} from '../../redux/actions/attachments';
import AttachmentFileMenu from '../../components/AttachmentFileMenu';
import { setAttachmentParams } from '../../redux/actions/general/attachments';
import {
  hideAlertbox,
  showAlertbox,
} from '../../redux/actions/general/alertbox';

@mapStateToProps((state) => ({
  flyout: state.table.products.flyout,
}))
class Images extends Component {
  constructor(props) {
    super(props);

    this.state = {
      expanded: [],
    };
  }

  @autobind
  _changeOrder(category, images) {
    setTableParams('products', {
      flyout: {
        ...this.props.flyout,
        images: _.map(this.props.flyout.images, (image, i) => {
          return image.category == category
            ? {
                ...image,
                order: _.findIndex(images, ['id', image.id]),
              }
            : image;
        }),
      },
    });
  }

  @autobind
  _downloadFile(row, download = false) {
    if (row.ext == 'pdf' && download == false) {
      window.open(row.stream_url, '_blank');
    } else {
      setNotification(
        __('products.flyout.files.products.files.download.continue')
      );

      window.open(row.download_url, '_blank');
    }
  }

  @autobind
  _refreshProduct() {
    return readProduct(this.props.flyout.id).then(({ response }) => {
      setTableParams('products', {
        flyout: response.data,
      });

      return response.data;
    });
  }

  @autobind
  _openEditAttachment(row) {
    hideDropdown();

    setAttachmentParams({
      edit_attachment_wizard: row,
      attachment_context: {
        type: 'product',
        product_id: this.props.flyout.id,
      },
    });

  }

  @autobind
  _openUploadAttachmentVersion(row) {
    hideDropdown();

    setAttachmentParams({
      upload_attachment_version_wizard: row,
      attachment_context: {
        type: 'product',
        product_id: this.props.flyout.id,
      },
    });

  }

  @autobind
  _archiveAttachment(row) {
    const is_archived = !!row.archived;
    const update_archive = is_archived
      ? unarchiveAttachment
      : archiveAttachment;

    hideDropdown();

    showAlertbox({
      color: 'blue',
      title: __('general.alert.are-you-sure'),
      description: is_archived
        ? __(
            'attachments.alert.unarchive-file',
            {},
            'Are you sure you want to unarchive this file?'
          )
        : __(
            'attachments.alert.archive-file',
            {},
            'Are you sure you want to archive this file?'
          ),
      buttons: [
        {
          color: 'lightGray',
          text: __('general.alert.no-close'),
          onClick: 'close',
        },
        {
          color: 'gray',
          text: is_archived
            ? __('attachments.button.unarchive', {}, 'Unarchive')
            : __('attachments.button.archive', {}, 'Archive'),
          onClick: () => {
            update_archive(row.attachment_id).then(() => {
              hideAlertbox();
              setNotification(
                is_archived
                  ? __(
                      'attachments.notification.unarchived',
                      {},
                      'File unarchived.'
                    )
                  : __(
                      'attachments.notification.archived',
                      {},
                      'File archived.'
                    )
              );
              this._refreshProduct();
            });
          },
        },
      ],
    });
  }

  @autobind
  _deleteFile(row) {
    hideDropdown();

    showAlertbox({
      color: 'red',
      title: __('general.alert.are-you-sure'),
      description: __(
        'products.flyout.files.are-you-sure.remove-file.products.alert'
      ),
      buttons: [
        {
          color: 'lightGray',
          text: __('general.alert.no-close'),
          onClick: 'close',
        },
        {
          color: 'gray',
          text: __('general.alert.yes-delete'),
          onClick: () => {
            deleteAttachmentCurrentVersion(row.attachment_id).then(() => {
              hideAlertbox();
              setNotification(
                __(
                  'products.flyout.files.file-has-been-deleted.products.notification'
                )
              );
              this._refreshProduct();
            });
          },
        },
      ],
    });
  }

  render() {
    const { flyout, category, data } = this.props;

    const images = _.sortBy(data, 'order');

    const lightbox_images = _.map(data, (image) => ({
      id: image.id,
      attachment_version_id: image.attachment_version_id,
      stream_url: image.stream_url,
      title: [image.name, image.ext].join('.'),
      download_url: image.download_url,
      ext: image.ext,
      width: image.width,
      height: image.height,
    }));

    return (
      <ReactSortable
        list={images.concat([{}])}
        setList={(list) => this._changeOrder(category, list)}
        animation={200}
        delayOnTouchStart={true}
        handle={'.' + styles.thumbnail}
        onEnd={() => {
          reorderProductImages(flyout.id, category, _.map(images, 'id')).then(
            () => {
              setNotification(
                __('product.flyout.images.product-images-order-saved')
              );

              if (category == 'thumbnail') {
                readProduct(flyout.id).then(({ response }) => {
                  setTableParams('products', {
                    flyout: {
                      ...flyout,
                      thumb_url: response.data.thumb_url,
                    },
                  });
                });

                listProducts();
              }
            }
          );
        }}
        onMove={(event) => !event.related.classList.contains(styles.add)}
        className={styles.content}
      >
        {_.map(images, (image, i) => (
          <div
            key={i}
            data-id={image.id}
            className={classNames(
              styles.thumbnail,
              image.archived && styles.archived
            )}
            onClick={() => showLightbox(lightbox_images, image.id)}
            style={{
              backgroundImage: "url('" + image.thumb_url + "')",
            }}
          >
            <div className={styles.grabber}>
              <GrabberIcon />
            </div>
            <div
              className={styles.attachmentMenu}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
              }}
            >
              <AttachmentFileMenu
                name={
                  'product_image_menu_' +
                  category +
                  '_' +
                  i +
                  '_' +
                  (image.attachment_id || image.id)
                }
                row={image}
                onDownloadFile={this._downloadFile}
                onOpenEdit={this._openEditAttachment}
                onOpenUploadVersion={this._openUploadAttachmentVersion}
                onArchiveAttachment={this._archiveAttachment}
                onDeleteFile={this._deleteFile}
                compact
              />
            </div>
          </div>
        ))}
      </ReactSortable>
    );
  }
}

export default Images;
